// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__FNOLPAWizard__buttonsContainer{display:flex;gap:10px;justify-content:right;margin-top:20px}", "",{"version":3,"sources":["webpack://./../common/wni-ce/capabilities-react/gwce-capability-fnol-pa-react-ext/FNOLPAWizard.module.scss"],"names":[],"mappings":"AAAA,qCACE,YAAA,CACA,QAAA,CACA,qBAAA,CACA,eAAA","sourcesContent":[".buttonsContainer {\n  display: flex;\n  gap: 10px;\n  justify-content: right;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonsContainer": "app__FNOLPAWizard__buttonsContainer"
};
export default ___CSS_LOADER_EXPORT___;
